import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Login } from '../../actions'

const randomString = function (length: number) {
  let text = ''
  let possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

// Sign up an account
export const signUpGuest = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { logger, apiClient }: Dependencies
) =>
  action$.filter(Login.signUpGuest.started.match).switchMap(() => {
    const password = randomString(32)
    return apiClient
      .createGeustUser(password)
      .switchMap(user =>
        apiClient
          // TODO: get version and build here
          .login(user.username, password, 'FIXME', 'FIXME')
          .map(loginResp => ({ user, loginResp }))
      )
      .map(({ user, loginResp }) =>
        Login.signUpGuest.done({
          params: undefined,
          result: {
            user,
            credentials: {
              userID: user.id,
              sessionKey: loginResp.sessionKeys[0].secretKey
            }
          }
        })
      )
      .catch((error: Rx.AjaxError) => {
        logger.error('Fail to sign up, error=', error)
        return Rx.Observable.of(
          Login.signUpGuest.failed({
            params: undefined,
            error: error.xhr.response.extra_info
          })
        )
      })
  })

export default combineEpics<Epic>(signUpGuest)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/signUpGuest.ts